// File: src/components/pages/ManageTracker.jsx
// ServiceProvider (Instructor) page - Manage lesson progress tracking
// Follows ManageBookings.jsx layout and structure

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import TrackerTemplates from './tracker/TrackerTemplates';
import BuildTracker from './tracker/BuildTracker';
import PublishTracker from './tracker/PublishTracker';
import ViewUpdateTracker from './tracker/ViewUpdateTracker';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/unified.css';

export default function ManageTracker() {
  const { user } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];

  const isServiceProvider = userRoles.includes('ServiceProvider');
  const isAdmin = userRoles.includes('admin');

  const [activeTab, setActiveTab] = useState('templates');

  const trackerTabs = [
    { key: 'templates',   label: 'Templates',    color: '#667eea' },
    { key: 'build',       label: 'Build Tracker', color: '#10b981' },
    { key: 'Published',     label: 'Published',       color: '#f59e0b' },
  ];

  // Access control - only ServiceProvider and admin can access this page
  if (!isServiceProvider && !isAdmin) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to instructors.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      {/* Status Tabs - Matching ManageBookings.jsx structure */}
      <div className="status-tabs">
        {trackerTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area - Matching ManageBookings.jsx structure */}
      <div className="page-content">
        {activeTab === 'templates'   && <TrackerTemplates />}
        {activeTab === 'build'       && <BuildTracker />}
        {activeTab === 'Published'     && <PublishTracker />}
        {activeTab === 'view-update' && <ViewUpdateTracker />}
      </div>
    </div>
  );
}
